import React from 'react';
import MoviePoster from '../MoviePoster';

import {Container} from './MoviesGrid.styles';

function MoviesGrid({items, onClickItem}) {
    return (
        <Container>
            {items.map((item, index) => (
                <MoviePoster
                    key={item.id}
                    data={item}
                    action={() => onClickItem(item.id)}
                />
            ))}
        </Container>
    );
}

export default MoviesGrid;
